import React from "react";
import "../../../src/assets/css/home.css";

const images = [
    { icon: "/assets/images/Home/Cert4.png", title: "Innovative Solutions" },
    { icon: "/assets/images/Home/Cert3.png", title: "Sustainable Practices" },
    { icon: "/assets/images/Home/Cert2.png", title: "Trusted by Retailers" },
    { icon: "/assets/images/Home/Cert1.png", title: "Certified Quality" },
];

export default function ImageLayout() {
    return (
        <section
            className="certifications-section pb-5"
        >
            <div className="text-center">
                <h2 className="text-primary py-5" data-aos="fade-up">
                    Certifications Offered
                </h2>

                <div className="certifications" data-aos="fade-left">
                    {images.map((img, idx) => (
                        <img
                            key={idx}
                            src={img.icon}
                            alt={img.title}
                            className="img-fluid"
                            style={{
                                maxWidth: "300px",
                                objectFit: "contain",
                            }}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
}